import styled from 'styled-components';
import MenuItem, {MenuItemProps} from '@material-ui/core/MenuItem';
import React from 'react';
import {Typography} from '../../typography';

const SelectMenuItemWrapper: any = styled(MenuItem)`
    &&& {
        margin: 0;
        border-radius: unset;
        color: ${(p) => p.theme.palette.common.black};
    }
    &&&.selected {
        background-color: ${(p) => p.theme.palette.neutral.chalk};
    }
    &&&:hover {
        background-color: ${(p) => p.theme.palette.neutral.chalk};
        color: ${(p) => p.theme.palette.common.black};
    }
    &&.Mui-focusVisible {
        background-color: unset;
    }
    &&&.Mui-focusVisible {
        background-color: ${(p) => p.theme.palette.neutral.chalk};
        color: ${(p) => p.theme.palette.common.black};
    }
`;

interface SelectInnerMenuItemProps extends MenuItemProps {
    children: React.ReactNode;
}

const SelectInnerMenuItem = ({
    children,
    itemRef,
    ...props
}: SelectInnerMenuItemProps): JSX.Element => {
    return (
        <SelectMenuItemWrapper ref={itemRef} classes={{selected: 'selected'}} {...props}>
            <Typography variant="p">{children}</Typography>
        </SelectMenuItemWrapper>
    );
};

export const SelectMenuItem = React.forwardRef<any, MenuItemProps>((props, ref: any) => {
    return (
        <SelectInnerMenuItem itemRef={ref} {...props}>
            {props.children}
        </SelectInnerMenuItem>
    );
});
